module.exports = __webpack_public_path__ + "img/cross.784939f4.svg";